export const actionButton =
    '<a class="action action-button button">\n'
    + "  <label>\n"
    + "    <svg>\n"
    + "      <use></use>\n"
    + "    </svg>\n"
    + '    <span class="title"></span>\n'
    + '    <input type="radio" name="">\n'
    + "  </label>\n"
    + "</a>\n";
